
<div class="generalPage" aria-label="help-pending content" role="main" *ngIf="outcome">
  <div class="pr-22 content-container pb-0 print-all-content" [ngClass]="IsRightPanel?'pt-0 pb-1-5rem-imp':''">
    <h1 class="generalHeader margin-0 content-blue bold itcHeavyFont pb-heading" role="heading">{{tereffile_header}}</h1>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="tereffile_content" [ngClass]="pt-0-5"></p>
    <p class="answer font-16 content-blue width-100 pb-heading" (contextmenu)="onRightClick($event)" (click)="openLinkById($event)" [innerHTML]="tereffile_link" [ngClass]="pt-0-5"></p>

  </div>
</div>
